export const educationData = [
    {
        id: 1,
        institution: 'Holmes Institute Dublin',
        course: 'Master of Strategic Information Systems',
        startYear: '2026',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'ALX-Africa (Holberton School)',
        course: 'Post-Graduate Certification in Software Engineering',
        startYear: 'Jan 2023',
        endYear: 'Jul 2024'
    },
    {
        id: 3,
        institution: 'Jomo Kenyatta University of Agriculture and Technology (JKUAT)',
        course: 'Bachelor of Science, Industrial Chemistry',
        startYear: 'Sept 2013',
        endYear: 'May 2017'
    },
    {
        id: 4,
        institution: 'Uasin Gishu High School',
        course: 'Kenya Certificate of Secondary Education (KCSE)',
        startYear: 'Jan 2008',
        endYear: 'Apr 2012'
    },
];
